import { useEffect, useState } from "react";

const useHideOnScroll = ({
  threshold = 30,
  scrollContainer = null,
  initiallyVisible = true,
} = {}) => {
  const [visible, setVisible] = useState(initiallyVisible);

  useEffect(() => {
    const target = scrollContainer || window;
    let lastScrollTop = 0;
    let ticking = false;

    const getScrollTop = () => {
      if (target === window) {
        return window.pageYOffset || document.documentElement.scrollTop || 0;
      }
      return target.scrollTop || 0;
    };

    const handleScroll = () => {
      if (ticking) {
        return;
      }
      window.requestAnimationFrame(() => {
        const currentScroll = getScrollTop();
        if (currentScroll <= threshold) {
          setVisible(true);
        } else if (currentScroll > lastScrollTop) {
          setVisible(false);
        } else if (currentScroll < lastScrollTop) {
          setVisible(true);
        }
        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
        ticking = false;
      });
      ticking = true;
    };

    target.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      target.removeEventListener("scroll", handleScroll);
    };
  }, [threshold, scrollContainer]);

  return visible;
};

export default useHideOnScroll;
